import avatar1 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/first avatar.png';
import avatar2 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/avatar 2.png';
import avatar3 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/Avatar · GA 3.png';
import avatar4 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/Avatar · GA 4.png';
import avatar5 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/cell B05.png';
import avatar6 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/cell B06.png';
import avatar7 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/cell G01.png';
import avatar8 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/cell G02.png';
import avatar9 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/cell G03.png';
import avatar10 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/cell G04.png';
import avatar11 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/cell G05.png';
import avatar12 from '../assets/img/2 MAIN SCREENS EN/Profile/Choose your character/cell G06.png';

export const profileAvatars = [
  avatar1, avatar2, avatar3, avatar4,
  avatar5, avatar6, avatar7, avatar8,
  avatar9, avatar10, avatar11, avatar12,
];

function fileKey(url) {
  try {
    const file = decodeURIComponent(String(url)).split('/').pop().split('?')[0].toLowerCase();
    return file.replace(/\.[a-f0-9]{8,}(?=\.[^.]+$)/, '');
  } catch {
    return '';
  }
}

export function avatarIndexFromSrc(src) {
  if (!src) return -1;
  const direct = profileAvatars.indexOf(src);
  if (direct !== -1) return direct;
  const key = fileKey(src);
  if (!key) return -1;
  return profileAvatars.findIndex((avatar) => fileKey(avatar) === key);
}
